<script setup></script>

<template>
  <div
    class="!mb-3 !rounded-br-2xl !rounded-tl-2xl !rounded-tr-2xl !bg-white !bg-opacity-60 !px-7 !py-6 !text-base"
  >
    <slot />
  </div>
</template>
